import { FC, JSX, useContext } from "react";
import { QESButton, WizardNavigationBar } from "../qes-standards";
import { FlyoutContext } from "./FlyoutContext";

interface FlyoutFooterProps {
    cancelButtonText?: string;
    submitButton: JSX.Element;
    onClose?: () => void;
}

const FlyoutFooter: FC<FlyoutFooterProps> = (props: FlyoutFooterProps) => {
    const flyoutContext = useContext(FlyoutContext);

    const handleClose = () => {
      if (!!props.onClose){
        props.onClose();
      }
      flyoutContext.handleCloseFlyout();
    }

    return (
        <WizardNavigationBar
            leftSide={
                <QESButton
                    qesType="secondary-danger"
                    qesTestId="side-panel__cancel-button"
                    onClick={handleClose}
                >
                    {props.cancelButtonText || "Cancel"}
                </QESButton>
            }
            rightSide={props.submitButton}
            isInAFlyout={true}
        />
    )
}

export default FlyoutFooter;